require('./Stamp.scss');

const React = require('react'),
    { PropTypes } = require('react');

const Stamp = React.createClass({displayName: "Stamp",
    propTypes: {
        srcImage: PropTypes.string,
        icon: PropTypes.string,
        text: PropTypes.string,
        badge: PropTypes.string,
        className: PropTypes.string,
        classNameIcon: PropTypes.string
    },

    getFontIcon(icon, classNameIcon, text) {
        return (
            React.createElement("i", {
                className: `bp-stamp__icon${text ? ' bp-stamp__icon-text' : ' bp-stamp__icon-non-text'}
                ${classNameIcon ? ' ' + classNameIcon : ''}`
            }, 
                icon ? icon : ''
            )
        );
    },

    getImageIcon(imageSrc) {
        if (!imageSrc) {
            return null;
        }
        return React.createElement("img", {className: "bp-stamp__image", src: imageSrc});
    },

    render() {
        const { imageSrc, text, className, icon, classNameIcon } = this.props;
        let classNameText = `bp-stamp${text ? ' ' + text : ' is-empty-text'}`;

        if (className) {
            classNameText = `${classNameText} ${className}`;
        }

        const iconEl = imageSrc
            ? this.getImageIcon(imageSrc)
            : this.getFontIcon(icon, classNameIcon, text);

        return (
            React.createElement("div", {className: classNameText, "data-text": text}, 
                React.createElement("div", {className: "bp-stamp__border-image"}, 
                    iconEl
                )
            )
        );
    }
});

module.exports = Stamp;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Stamps/Stamp/Stamp.js
 **/